<template>
    <!--Start Page Banner-->
    <div class="page-banner-area bg-1">
            <div class="container">
                <div class="page-banner-content">
                    <h1>Sports Club</h1>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li>Student Corner</li>
                        <li>Cells</li>
                        <li>Sports Club</li>
                    </ul>
                </div>
            </div>
        </div>
        <!--End Page Banner-->

        <!--Start Sport club Area-->
        <div class="privacy-policy-area pt-100 pb-70">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8">
                        <div class="privacy-content pr-20">
                            <h3>Vision</h3>
                            <p>To see maximum students live a healthy and active lifestyle, not only during college days
                                but throughout their life and provide those with exceptional sporting talents a launch
                                pad for Sporting career</p>

                            <h3>Mission</h3>
                            <p>To become the most preferred service provider for college sports programs.
                                To help the college students pursue sports as a career.
                                To create awareness about physical fitness through sports among people of all age
                                groups.
                                To work on the overall development of a students leading to a complete personality
                                development.</p>

                            <h3>We have a unique approach to accomplish our objectives:</h3>
                            <p>Incorporating both physical development through a selected sports and mental growth
                                through Yoga and Meditation practices.
                                <br />
                                Regularly inviting Sports Personalities to share their experiences with the Students and
                                give suggestions making it not only a motivating interaction but also creating an impact
                                on them to follow important guidelines from their own role models.
                                <br />
                                Coaching will not only include the How to Player aspect but also the who whom of the
                                game, studying game plans of existing teams and their players.
                                Watching videos of International games to understand tactics and then learn and improve
                                their own.
                                <br />
                                Selecting the best players and giving them advance coaching so that they can represent
                                the club at state and national levels.
                                <br />
                                Regularly arranging a parent meet to show the progress of their child.
                            </p>

                            <h3>Members</h3>
                            <ul>
                                <li>Sohani Lamba – Coordinators</li>
                                <li>Kamala Choudhary - Physical Instructor</li>
                                <li>Kirtika Panjwani - Committe Members</li>
                                <li>Nishtha Dutta - Committe Members</li>
                                <li>Dipti Sharma - Committe Members</li>
                                <li>Kusum Sharma - Committe Members</li>
                                <li>Pawan Kumar Jangid - Committe Members</li>
                            </ul>


                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="privacy-left-content pl-20">
                            <div class="team-img-box"> <img width="460" height="500"
                                    src="vf/images/cells/sport_club_c4.png"
                                    class="attachment-post-thumbnail size-post-thumbnail wp-post-image" alt=""
                                    decoding="async" fetchpriority="high"></div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!--End Sport club Area-->


        <!-- Start Bottom Connect Area -->
         <div class="alumni-interview-area pb-100">
            <div class="container">
                <div class="interview-content ptb-100">
                    <div class="interview">
                        <a href="https://rdc.eshala.co.in/events" class="default-btn btn">Events<i
                                class="flaticon-next"></i></a>
                        <a href="https://rdc.eshala.co.in/page/enquiry" class="default-btn btn">Apply Now<i
                                class="flaticon-next"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <!--End Bottom Connect Area -->
</template>

<script>
export default {
    name : "WDCView"
};
</script>
